'use client';

import './home-mobile.scss';
import { useRef } from 'react';
import { useScrambleIn } from '@/lib/hooks/useScrambleIn';
import { useSwiperSlide } from 'swiper/react';

export default function LoadingCapabilities() {
  const swiperSlide = useSwiperSlide();
  const rootRef = useRef<HTMLDivElement>(null);

  useScrambleIn(rootRef, { active: swiperSlide.isActive, staggerMs: 100, durationMs: [1000, 1500] });

  return (
    <div ref={rootRef} className={`capabilities-slide`}>
      <div>
        <h2 className='text-gray' data-scramble-in>{`< Loading Capabilities >`}</h2>
        <ul>
          <li data-scramble-in>{'< loading > creative direction : OK'}</li>
          <li data-scramble-in>{'< loading > branding design: OK'}</li>
          <li data-scramble-in>{'< loading > interaction design : OK'}</li>
          <li data-scramble-in>{'< loading > character design : OK'}</li>
          <li data-scramble-in>{'< loading > motion design : OK'}</li>
          <li data-scramble-in>{'< loading > production : OK'}</li>
          <li data-scramble-in>{'< loading > front-end : OK'}</li>
          <li data-scramble-in>{'< loading > back-end : OK'}</li>
          <li data-scramble-in>{'< loading > ui.ux : OK'}</li>
          <li data-scramble-in>{'< loading > web 3.0 : OK'}</li>
        </ul>
        <p className='text-gray' aria-hidden="true">{'<>'}</p>
      </div>
      <div>
        <h2 className='text-gray' data-scramble-in>{`< Trust The Process >`}</h2>
        <p data-scramble-in>{'To experiment is to invite challenges,'}</p>
        <p data-scramble-in>{'and sometimes, chaos.'}</p>
        <br></br>
        <p data-scramble-in>{"And now, we're inviting you to the lab"}</p>
        <p data-scramble-in>{"to watch it all happen. "}</p>
        <p className='text-gray'>{'<>'}</p>
        <p data-scramble-in>{'A small lab with big experiments.'}</p>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <span data-scramble-in>{'Awaiting next steps ...'}</span>
          <span className="capabilities-slide-arrows">{'>>>'}</span>
        </div>
      </div>
    </div>
  )
};